import React from "react";
import { DataHelper } from "../Helpers/DataHelper";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import ChartD3 from "./ChartD3";
import { StudyModel } from "../Models/StudyModel";
import { LoadingWidget } from "./LoadingWidget";
import { Graft } from "../Models/Trigger/TriggerClasses";
import { ReferenceValuesModel } from "../Models/ReferenceValuesModel";
import { UploadDataHelper } from "../Helpers/SharedClasses";

export class MiniTTFMCurve extends React.Component<
    {
        subType: string,
        studySelected: StudyModel,
        dataReceiver: DataHelper, 
        measurementPreview: PreviewMeasurement,
        procedureid: string,
        width: number, 
        height: number,
        usefilling: boolean
        color: string, 
        color1: string, 
        color2: string, 
        color3: string, 
        includeScrubber: boolean,
        yAxisVisible: boolean,
        xAxisVisible: boolean,
        parentGroup: string,
        xAxisMax: number
    },
    {
        axisSize: number,
        cursorPosition: number, 
        dataLoaded: boolean,
        errorMessage: string,
        meanFlow: number,
        meanACI: number,
        pulsatilityIndex: number,
        diastolicFilling: number,
        indexConfig: ReferenceValuesModel
    }
> {

    ;
    currentData: any = null;
    holderDiv: React.RefObject<HTMLDivElement>;
    ttfmChartd3: React.RefObject<ChartD3>;
    fullXAxisSize: number = 1000; 
    constructor(props: any) {
        super(props);
        this.holderDiv = React.createRef();
        this.ttfmChartd3 = React.createRef();
        
            this.fullXAxisSize = this.props.xAxisMax;

        
        let uploadHelper: UploadDataHelper = new UploadDataHelper();
        this.state = {
            axisSize: this.fullXAxisSize,
            cursorPosition: this.fullXAxisSize,
            dataLoaded: false,
            errorMessage: "",
            meanFlow: Math.abs(this.props.measurementPreview.mean as number)  *1000,
            meanACI: (this.props.measurementPreview.aCIMean as number),
            pulsatilityIndex: (this.props.measurementPreview.pI as number),
            diastolicFilling: (this.props.measurementPreview.dF as number),
            indexConfig: uploadHelper.getDefaultIndexConfiguration(this.props.studySelected)
        }
        

    }

    addDataPoints = (dataToRenderAll: any, compareMode = false, scrubberPos = 0) =>
    {
        let colorPalette = [this.props.color1, this.props.color3, "var(--Raven)", "var(--GreenApple)", "var(--Crocodile)", "var(--BananaClan)", "var(--Bluejay)", "var(--FireEngineRed)"]
        let MainKey = "BLUE";
        let reservedKeys = ["Phase", "PhaseFull", "ECG", "PI", "ACI", "x", "DFOLD", "DF"];
        let ttfmChartd3: ChartD3 = (this.ttfmChartd3.current as ChartD3);
      if (!ttfmChartd3)
        return;
   
      let xAxisSize = this.fullXAxisSize;
      let yAxisMin = 0;
      let yAxisMax = 0;

         if (this.props.measurementPreview.displayRangeMax !== 0)
        {
                yAxisMin = this.props.measurementPreview.displayRangeMin as number * 1000;
                yAxisMax = this.props.measurementPreview.displayRangeMax as number * 1000;
        }

        if(yAxisMin===0 && yAxisMax===0){
      if (dataToRenderAll)
      {

        //   let reservedKeys = ["Phase", "PhaseFull", "ECG", "PI", "ACI", "x", "DFOLD", "DF"];

          for (let dataProp in dataToRenderAll) {
              if (reservedKeys.indexOf(dataProp) === -1)
              {
              const dataValues = dataToRenderAll[dataProp];
              if (dataValues && dataValues.length > 0) {
                  for (let index = 0; index < dataValues.length; index++) {
                      const element = dataValues[index];
                      if (yAxisMin > element)
                      {
                          yAxisMin = element;
                      }
                      if (yAxisMax < element)
                      {
                          yAxisMax = element;
                      }
                      
                  }
              }
              }

          }
        }
      }

      ttfmChartd3.resetDrawingArea(null, null, yAxisMin, yAxisMax, xAxisSize, 0, 0 );
      let seriesIndex = 0;
      for (let dataProp in dataToRenderAll) {
          if (reservedKeys.indexOf(dataProp) === -1)
          {
          const dataValues = dataToRenderAll[dataProp];
          if (dataValues && dataValues.length > 0) {
              if (dataProp === MainKey)
              {
            if ((dataToRenderAll["PhaseFull"] && dataToRenderAll["PhaseFull"].length > 0) || (dataToRenderAll["Phase"].length > 0 )){ //&& dataToRenderAll["Phase"] &&dataToRenderAll["Phase"].length > 0) {

             
            
                if (dataToRenderAll["PhaseFull"] && dataToRenderAll["PhaseFull"].length > 0 )
                {
                    //First draw a filled line with no change in phase and mark the items added with their x value.
                ttfmChartd3.addAreaData(dataToRenderAll[dataProp], this.props.color1, "TTFM", dataToRenderAll["x"], compareMode, scrubberPos);
                ttfmChartd3.setAreaColor(dataToRenderAll["PhaseFull"], this.props.color2, this.props.color2);
                }
else if (dataToRenderAll["Phase"].length > 0 )
{

                var phaseMarker = -1;
                var lastDrawn = 0;
                for (let index = 0; index < dataToRenderAll["Phase"].length; index++) {
                    const element = dataToRenderAll["Phase"][index];
                    if (element !== phaseMarker) {
                        if (phaseMarker === -1) {
                            phaseMarker = element;
                        } else {
                            ttfmChartd3.addAreaData(dataToRenderAll[dataProp].slice(lastDrawn, index), ((phaseMarker === 1)
                                ? this.props.color1
                                : this.props.color2), "TTFM", dataToRenderAll["x"].slice(lastDrawn, index), compareMode, scrubberPos);
                            phaseMarker = element;
                          //  datapointsaddedblue = datapointsaddedblue - lastDrawn + index;
                            lastDrawn = index;
                        }
                    }
    
                }
                if (lastDrawn < dataToRenderAll[dataProp].length) {

                    let lastPhaseCutoff = 135;
                    if (dataToRenderAll[dataProp].length - lastDrawn > lastPhaseCutoff)
                    {
                        //If it wasn't drawn all the way to the end the draw the last bit.
                        ttfmChartd3.addAreaData(dataToRenderAll[dataProp].slice(lastDrawn, dataToRenderAll[dataProp].length-lastPhaseCutoff), ((phaseMarker === 1)
                            ? this.props.color1
                            : this.props.color2), "TTFM", dataToRenderAll["x"].slice(lastDrawn, dataToRenderAll[dataProp].length-lastPhaseCutoff), compareMode, scrubberPos);

                         //add the last 100 switched in color? This must be something to do with the way the MiraQ software renders the Filling.
                        lastDrawn = dataToRenderAll[dataProp].length-lastPhaseCutoff;
                    }
                   
                    ttfmChartd3.addAreaData(dataToRenderAll[dataProp].slice(lastDrawn, dataToRenderAll[dataProp].length), ((phaseMarker === 1)
                        ? this.props.color2
                        : this.props.color1), "TTFM", dataToRenderAll["x"].slice(lastDrawn, dataToRenderAll[dataProp].length), compareMode, scrubberPos);

                }

            }else
            {
                ttfmChartd3.addAreaData(dataToRenderAll[dataProp], this.props.color1, "TTFM", dataToRenderAll["x"], compareMode, scrubberPos);
            }
                
            }else
            {
                //Override the first color to something darker when there is no filling.
                ttfmChartd3.addLineData(dataToRenderAll[dataProp], this.props.color1 === "var(--SassySalmon)" ? "var(--Lacustral)" : this.props.color1, "TTFM", dataToRenderAll["x"], compareMode, scrubberPos);
            }
        }else{

            let colorToUse = colorPalette[seriesIndex];
            if (dataProp === "RED")
                colorToUse = colorPalette[1];
            ttfmChartd3.addLineData(dataToRenderAll[dataProp],colorToUse, dataProp, dataToRenderAll["x"], compareMode, scrubberPos);

        }

          }
          seriesIndex++;
        }
        
   
      }
    }

    convertSecondsToDataPoints = (valueInSeconds: number) =>
        {
            let recordedLength = this.props.measurementPreview.recordedLength;
            if (!recordedLength)
                recordedLength = 60.0;
            
            let sweepLength = this.props.measurementPreview.sweepLength;
            if (!sweepLength)
                sweepLength = 5.0;
            // let sweepPosition = this.props.measurementPreview.sweepPosition;
            // if (!sweepPosition)
            //     sweepPosition = 0.0;
    
            let ratioSecondsToDataPoints = (this.currentData["x"].length/recordedLength);
    
            let posInDataPointsRelative = (recordedLength - valueInSeconds) * ratioSecondsToDataPoints;
            return posInDataPointsRelative;
            
        }


    adjustScrubberInSeconds = (valueInSeconds: number) =>
    {
        // let recordedLength = this.props.measurementPreview.recordedLength;
        // if (!recordedLength)
        //     recordedLength = 60.0;
        // let sweepLength = this.props.measurementPreview.sweepLength;
        // if (!sweepLength)
        //     sweepLength = 5.0;
        // // let sweepPosition = this.props.measurementPreview.sweepPosition;
        // // if (!sweepPosition)
        // //     sweepPosition = 0.0;

        // let ratioSecondsToDataPoints = (this.state.axisSize/recordedLength);

        // let posInSecondsRelative = (recordedLength - valueInSeconds) * ratioSecondsToDataPoints;

        // let scrubberPosInDataPoints = this.state.axisSize;
        let posInDataPointsRelative = this.convertSecondsToDataPoints(valueInSeconds);
        this.adjustScrubber(posInDataPointsRelative);
    }

    analyzeWindow = (dataFlow: number[], dataACI: number[], dataPI: number[], dataMean: number[], dataDF: number[], position: number, windowSize: number = 1000)=> {
        if (!dataFlow || dataFlow.length === 0) return { meanFlow: 0, pi: 0 };
        
        const start = Math.max(0, position - windowSize);
        const end = position;
        if (!dataACI) dataACI = [];
        const flowValues = dataFlow.slice(start, end);
        const ACIValues = dataACI.slice(start, end);
        
        if (flowValues.length === 0) return { meanFlow: 0, pi: 0 };
       
        
        const peakSystolic = Math.max(...flowValues);
        const endDiastolic = Math.min(...flowValues);
        let meanFlowSubset = flowValues.reduce((acc, val) => acc + val, 0) / flowValues.length;
        let meanACISubset = ACIValues.reduce((acc, val) => acc + val, 0) / ACIValues.length;
        let pi = meanFlowSubset !== 0 ? (peakSystolic - endDiastolic) / Math.abs(meanFlowSubset) : 0;
        let dfOut: number = 0;
        position = Math.round(position);
        meanFlowSubset = dataMean[position >= dataMean.length ? dataMean.length-1 : position];
        meanACISubset = dataACI[position >= dataACI.length ? dataACI.length-1 : position];
        pi = dataPI[position >= dataPI.length ? dataPI.length-1 : position]/1000;
        if (dataDF)
        {
            dfOut = dataDF[position >= dataDF.length ? dataDF.length-1 : position];
        }else
            dfOut = this.props.measurementPreview.dF as number;
        return { meanFlowSubset, pi, meanACISubset, dfOut };
    }

    adjustScrubber = (value: number) =>
    {
        if (!this.currentData?.BLUE || !this.currentData?.PI ) return;

        const { meanFlowSubset, pi:pulsatilityIndex, meanACISubset, dfOut } = this.analyzeWindow(this.currentData.BLUE, this.currentData.ACI, this.currentData.PI, this.currentData.RED, this.currentData.DF, value);

        
        this.setState({ 
            cursorPosition: value,
            meanFlow: meanFlowSubset as any,
            meanACI: meanACISubset as any,
            pulsatilityIndex: pulsatilityIndex,
            diastolicFilling: dfOut as number,
        }, ()=> {
        this.addDataPoints(this.currentData, true, value); 

    
    });
       //this.state.cursorPosition = value;
       this.setState({ cursorPosition: value}, ()=> {this.addDataPoints(this.currentData, true, value); })
        
    }
    
    formatXAxisLabels = (value: number) =>
    {
        return "";
        //return value/200 + "s";
    }

     static defaultProps ={
        subType: "Flow",
        width:240,
        height: 120,
        usefilling: false,
        includeScrubber: false,
        color: "black",
        color1: "var(--SassySalmon)",
        color2: "var(--WaterySea)",
        color3: "var(--Lacustral)",
        yAxisVisible: true,
        xAxisVisible: true,
        parentGroup: "",
        xAxisMax: 1000
     }

     onVisible = (element: Element, callback: (e:Element) => void) => {
        new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {
              callback(element);
              observer.disconnect();
            }
          });
        }).observe(element);
    }
    
    refreshData = (callback: () => void)=>
    {
        if (this.props.measurementPreview.id && !this.currentData)
        {
             if (this.props.measurementPreview.indicesColorGraded && this.props.measurementPreview.indexConfigurationId)
                {
                    this.props.dataReceiver.GetIndexConfig(this.props.studySelected.id as string,  this.props.measurementPreview.indexConfigurationId, (indexConfig: ReferenceValuesModel)=>
                    {
                        if (indexConfig)
                        {
                            this.setState({
                                indexConfig: indexConfig
                            });
                        }
                    });
                }
            this.props.dataReceiver.CallService("MiscData", "GetFlowData", {}, { studyId: this.props.studySelected.id, measurementId: this.props.measurementPreview.id, measurementType: this.props.subType, procedureid: this.props.procedureid, tokenId: this.props.dataReceiver.miscToken},  (measurementDataRaw: string)=>{
            this.currentData = {};

            if (measurementDataRaw)
            {
            this.currentData = JSON.parse(measurementDataRaw);
     
            this.addDataPoints( this.currentData, true, this.convertSecondsToDataPoints(this.props.measurementPreview.sweepPosition ?this.props.measurementPreview.sweepPosition : 0));
            this.setState({
                axisSize: this.currentData["x"].length,
                cursorPosition: this.convertSecondsToDataPoints(this.props.measurementPreview.sweepPosition ?this.props.measurementPreview.sweepPosition : 0),
                dataLoaded: true  
             }, callback);
            }else
            {
                this.setState({
                    errorMessage: "No flow measurement data found.",
                    dataLoaded: true
                 });
            }
        }, (errorVal: any) =>
        {
            this.setState({
                errorMessage: "Unable to load measurement",
                dataLoaded: true
             });
            console.log("Error loading thumbnail data.")
        }, "GET", false);
        }
    }


    componentDidMount(): void {
        if (this.holderDiv.current)
        this.onVisible(this.holderDiv.current, (e: Element) =>
        {
            this.refreshData(()=>{

            

                this.adjustScrubberInSeconds(this.props.measurementPreview.sweepPosition as number);//1000 is the default position of one full "screen" of data.

            });
        });

      
    }


    render() {

        let meanValue= Math.abs(this.props.measurementPreview.savedMean ? this.props.measurementPreview.savedMean : this.state.meanFlow);
        // if (this.props.measurementPreview.lastMean)
        // {
        //     meanValue = Math.abs((this.props.measurementPreview.lastMean as number));
        // }
        let lowerValue = this.state.indexConfig.meanLowerReferenceValue as number;
        let upperValue = this.state.indexConfig.meanUpperReferenceValue as number;

        let lowerValueAci = this.state.indexConfig.aciLowerReferenceValue as number;
        let upperValueAci= this.state.indexConfig.aciUpperReferenceValue as number;
        let aciIn = this.props.measurementPreview.savedACI ? this.props.measurementPreview.savedACI : this.state.meanACI;

        // if (this.props.measurementPreview.lastACI)
        //     {
        //         aciIn = (this.props.measurementPreview.lastACI as number);
        //     }

        let piValue = this.props.measurementPreview.savedPI ? this.props.measurementPreview.savedPI : this.state.pulsatilityIndex;

        // if (this.props.measurementPreview.lastPI)
        //     {
        //         piValue = (this.props.measurementPreview.lastPI as number);
        //     }

        let piLowerValue = this.state.indexConfig.piLowerReferenceValue as number;
        let piUpperValue = this.state.indexConfig.piUpperReferenceValue as number;

        let meanflowColor = ( meanValue< lowerValue? this.state.indexConfig.meanGoodColor: meanValue > upperValue? this.state.indexConfig.meanWorstColor: this.state.indexConfig.meanBadColor);
        let piColor = "";
        if (piValue)
            piColor = ( piValue< piLowerValue? this.state.indexConfig.piGoodColor: piValue > piUpperValue? this.state.indexConfig.piWorstColor: this.state.indexConfig.piBadColor) as string;
        let aciColor = "";
        if (aciIn)
            aciColor =  ( aciIn< lowerValueAci? this.state.indexConfig.aciGoodColor: aciIn > upperValueAci? this.state.indexConfig.aciWorstColor: this.state.indexConfig.aciBadColor) as string;
                       

        let fullAnatomicalLocation = this.props.measurementPreview.anatomicalLocations?.join("-") as string;
        if (!fullAnatomicalLocation)
          fullAnatomicalLocation = this.props.measurementPreview.vessels?.join("-") as string;
        if (!fullAnatomicalLocation)
        {
            if (this.props.measurementPreview != null && this.props.measurementPreview.intuiGraft != null)
            {
                let anatomicalLocations: string[] = [];
                Graft.getGraftName(this.props.measurementPreview.intuiGraft, anatomicalLocations);
                fullAnatomicalLocation = anatomicalLocations?.join('-');
            }
        }   
        return (
            <>
               <div className="thumbnail-container" ref={this.holderDiv}>
               {this.props.subType === "Flow" ? 
               <div className={"thumbDataItem thumbnail-mean "} style={{backgroundColor: meanflowColor}}><label>MF: </label>{meanValue.toFixed(2)}<span className="thumbUnits">mL/min</span></div>
               : <></>}
                 {/* <div className="thumbnail-serialnumber">{this.props.measurementPreview.probeSerialNumber}</div> */}
                <div className="thumbnailGraphic">
                {
                    this.state.errorMessage ?
                    <div className="thumbnailError">{this.state.errorMessage}</div>
                    :
                    <><LoadingWidget visible={!this.state.dataLoaded} zIndexLayer={0}></LoadingWidget>
                    <ChartD3
                      ref={this.ttfmChartd3}
                      id={"FLOWDIAG"+this.props.parentGroup+this.props.measurementPreview.id}
                      autoscroll={true}
                      width={this.props.width}
                      height={this.props.height}
                      yaxismin={0}
                      yaxismax={10}
                      xaxisposition={0}
                      xaxismax={this.fullXAxisSize}
                      yAxisVisible={this.props.yAxisVisible}
                      xAxisVisible={this.props.xAxisVisible}
                      color="var(--WaterySea)"
                      colorOutline="var(--dolphin)"
                      yAxisLabel=""
                      margintop={5}
                      marginleft={5}
                      marginright={5}
                      marginbottom={5}
                      xAxisLabelsFormat={()=>{return"";}}
                      yAxisLabelsFormat={()=>{return"";}}
  
                      yAxisMinimal={true}
                      ></ChartD3></>
                }
                </div>
                {this.props.subType === "Flow" ? 
                <div className="thumbnail-data-wrap">
                    <div className="thumbnailData">
                        <div  className={"thumbDataItem thumbnail-aci "} style={{backgroundColor: aciColor}}><label>ACI: </label>{aciIn ?  (aciIn).toFixed(0) :aciIn }</div>
                        <div className={"thumbDataItem thumbnail-pi "} style={{backgroundColor: piColor}}><label>PI: </label>{piValue ? (piValue as number).toFixed(2) :piValue}</div>
                    </div>
                    <div className="thumbDataItem thumbnail-date"><label>Date: </label>{new Date(this.props.measurementPreview.recordDate as Date)?.toLocaleString()}</div>
                    <div className="thumbDataItem thumbnail-label"><label>Location: </label><span className="thumbnailContent">{fullAnatomicalLocation}</span></div>
                    <div className="thumbDataItem thumbnail-label protocolStep"><label>Protocol step: </label><span className="thumbnailContent">{this.props.measurementPreview.protocolStep}</span></div>
                </div>: <></>}
                
            </div>
            </>
        );
    }
}
